<template>
  <base-modal-bottom
    ref="baseModalError"
    class="has-text-centered"
    :isFooter="true"
    :title="title"
  >
    <template #btn-close-icon>
      <base-icon
        style="margin: 0 auto"
        width="16"
        height="16"
        name="painel/close-icon"
      />
    </template>
    <div class="margin-bottom">
      <base-icon width="90" height="115" :name="icon" />
    </div>
    <div class="margin-bottom title-message" v-html="message">
      <p>{{ message }}</p>
    </div>
    <p
      class="margin-bottom subtitle-message"
      v-if="!hiddenMessage"
      v-html="subMessage"
    ></p>
    <template #footer>
      <base-button-bottom
        v-if="hasButton"
        @click.native="close"
        class="is-primary is-big"
        type="button"
      >
        {{ buttonMessage }}
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  props: {
    title: {
      type: String,
      default: 'Erro na solicitação',
    },
    icon: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: 'Erro na solicitação',
    },
    subMessage: {
      type: String,
      default: 'Por favor, tente novamente<br />em alguns instantes',
    },
    buttonMessage: {
      type: String,
      default: 'Ok, entendi!',
    },
    hiddenMessage: {
      type: Boolean,
      default: false,
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  methods: {
    open() {
      this.$refs.baseModalError.open()
    },
    close() {
      this.$refs.baseModalError.close()
    },
  },
}
</script>

<style lang="scss">
.title-message,
.subtitle-message {
  max-width: 429px;
  margin: 0 auto;
  margin-bottom: 16px;

  .txt-color-support {
    color: #048a8b;
    font-weight: bold;
  }
}
</style>
